export default __webpack_public_path__ + "static/media/ic_link.e_40.4bb3a048.svg";